module.exports = __webpack_public_path__ + "resources/img/bg_cover_pricing_m.bab849706e1a362651a961136ee654f6.png";